/**
 * @owner @Appboy/reporting
 */
export const subscriptionGroupAnalytics = "/subscription_group_analytics/:app_group_id";

export const subscriptionGroupAnalyticsCacheKeys = subscriptionGroupAnalytics;
